import { Expose } from 'class-transformer';

export class VoucherPurchaseItemApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  priceAdjustment: number;
}
